reFetchObservableQueries